import React from 'react';

import styles from './ActionsWrapper.module.scss';

const ActionsWrapper = ({ children }) => {
    return <div className={styles.actionsWrapper}> {children} </div>;
};

export default ActionsWrapper;
